import { render } from "./AdyenPaymentMethodGroup.vue?vue&type=template&id=0da4cedd"
import script from "./AdyenPaymentMethodGroup.vue?vue&type=script&lang=js"
export * from "./AdyenPaymentMethodGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__